import { createContext } from 'react';
import React from 'react';

import { ServiceType } from './types';

export const ServiceContext = createContext<{ serviceType: ServiceType }>({});

interface ServiceContextProviderProps {
  serviceType: ServiceType;
  client?: any;
  children: React.ReactNode;
}

export const ServiceContextProvider = ({ serviceType, client, children }: ServiceContextProviderProps) => {
  return <ServiceContext.Provider value={{ serviceType }}>{children}</ServiceContext.Provider>;
};
